import React, {Fragment, useState} from "react";
import {currency} from "./Helper";


function ChoiceListItem({group, choice, update, checked}) {
    return <li className={"hg-cake-choice-item"}>
        <label htmlFor={"_choice_list_" + choice.tag}>
            <input type="radio" id={"_choice_list_" + choice.tag} name={"_choice_list_" + group}
                   onChange={update}
                   value={choice.tag} checked={checked} />
                <span className={"hg-cake-choice-item__text"}>
                    <div className={"hg-cake-choice-item__name"}>{choice.name}</div>
                    <div className={"hg-cake-choice-item__description"} dangerouslySetInnerHTML={{__html: choice.description}}></div>
                    <div className={"hg-cake-choice-item__price"}>{currency(choice.price)}</div>
                </span>
        </label>
    </li>;
}

function ChoiceListItemWithOptions({group, config, choice, options, update, value}) {
    return <li key={choice.tag} className={"hg-cake-choice-item hg-cake-choice-item--with-options"}>
        <label>
            <span className={"hg-cake-choice-item__text"}>
                <div className={"hg-cake-choice-item__name"}>{choice.name}</div>
                <div className={"hg-cake-choice-item__description"} dangerouslySetInnerHTML={{__html: choice.description}}></div>
            </span>
        </label>
        <ul className={"hg-cake-choice-item__options"}>
            {options.map((option) => {
                const checked = value === option.tag;

                return <li key={option.tag}>
                    <label htmlFor={"_choice_list_" + option.tag}>
                        <input type="radio" id={"_choice_list_" + option.tag} name={"_choice_list_" + group + '_' + choice.tag}
                               onChange={update}
                               value={option.tag} checked={checked} />
                        <span className={"hg-cake-choice-item__text"}>
                            <div className={"hg-cake-choice-item__name"}>
                                {option.name}
                                <div className={"hg-cake-choice-item__price"}>{currency(option.price)}</div>
                            </div>
                        </span>
                    </label>
                </li>
            })}
        </ul>
    </li>;
}

export default function ChoiceList({ config, group, choices, value, onChange }) {
    const update = (e) => onChange(e.target.value);

    return <ul className={"hg-cake-choice-list hg-cake-choice-list--" + group}>
        {choices.map((choice) => {

            if (choice.options && Array.isArray(choice.options)) {
                return <ChoiceListItemWithOptions group={group}  key={choice.tag}
                                                  choice={choice} config={config}
                                                  options={choice.options.map((t) => config.items[t])}
                                                  update={update}
                                                  value={value}
                                                  />;
            }

            return <ChoiceListItem  key={choice.tag}  group={group} choice={choice} update={update} checked={value === choice.tag} />;
        })}
    </ul>

}


// WEBPACK FOOTER //
// ./js/cake/ChoiceList.js